import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'partners'

AdminRouter.addRoutes([
  {
    name: `${base}`,
    path: `/${base}`,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.commissions`,
    path: `/${base}/:partner_id/commissions`,
    component: () => import('./Commissions.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `partner.commissions`,
    path: `/commissions`,
    component: () => import('./Commissions.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `partner.orders`,
    path: `/orders`,
    component: () => import('./Orders.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `partner.widget`,
    path: `/widget`,
    component: () => import('../widget/Widget.vue'),
    props: {
      defaults: {
        showArrivalBooking: true,
        blank: false,
        hideRideTypes: ['transfer', 'delivery'],
      },
    },
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 60,
  header: $vm => $vm.$t(`general.menu_management`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-tree5',
  permission: 'users.partners',
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 90,
  header: $vm => $vm.$t(`partners.settings.menu_partner_settings`),
  text: $vm => $vm.$t(`partners.settings.menu_partner_settings`),
  icon: 'icon-cog',
  permission: $vm => {
    return ($vm.$account && $vm.$account.partner) || ($vm.$account && $vm.$account.company)
  },
  children: [
    {
      id: `partner.commissions`,
      order: 30,
      header: $vm => $vm.$t(`general.menu_partner`),
      text: $vm => $vm.$t(`partners.commissions_title`),
      route: {
        name: `partner.commissions`,
      },
      icon: 'icon-percent',
    },
    {
      id: `partner.orders`,
      order: 30,
      header: $vm => $vm.$t(`general.menu_partner`),
      text: $vm => $vm.$t(`partners.orders_title`),
      route: {
        name: `partner.orders`,
      },
      icon: 'icon-coins',
    },
    {
      id: `partner.orders1`,
      order: 30,
      header: $vm => $vm.$t(`general.menu_partner`),
      text: $vm => $vm.$t(`partners.widget_title`),
      route: {
        name: `partner.widget`,
      },
      icon: 'icon-circle-code',
    }
  ],
});

// AdminSidebar.pushItem({
//   id: `partner.commissions`,
//   order: 30,
//   header: $vm => $vm.$t(`general.menu_partner`),
//   text: $vm => $vm.$t(`partners.commissions_title`),
//   route: {
//     name: `partner.commissions`,
//   },
//   icon: 'icon-percent',
//   permission: $vm => {
//     return $vm.$account && $vm.$account.partner
//   },
// })
//
// AdminSidebar.pushItem({
//   id: `partner.orders`,
//   order: 30,
//   header: $vm => $vm.$t(`general.menu_partner`),
//   text: $vm => $vm.$t(`partners.orders_title`),
//   route: {
//     name: `partner.orders`,
//   },
//   icon: 'icon-coins',
//   permission: $vm => {
//     return $vm.$account && $vm.$account.partner
//   },
// })
//
// AdminSidebar.pushItem({
//   id: `partner.orders`,
//   order: 30,
//   header: $vm => $vm.$t(`general.menu_partner`),
//   text: $vm => $vm.$t(`partners.widget_title`),
//   route: {
//     name: `partner.widget`,
//   },
//   icon: 'icon-circle-code',
//   permission: $vm => {
//     return $vm.$account && $vm.$account.partner
//   },
// })

messageGroups.push(base)
